"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FAVORITE_PROMO_CODES_COUNT = exports.MAX_PROMO_CODE_LENGTH = exports.MIN_PROMO_CODE_LENGTH = exports.ALLOWED_CHARACTERS_REGEX = exports.PROMO_CODE_ALLOWED_CHARACTERS = void 0;
exports.PROMO_CODE_ALLOWED_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
exports.ALLOWED_CHARACTERS_REGEX = /^[!@#$%&*_\-a-zA-Z0-9]*$/;
exports.MIN_PROMO_CODE_LENGTH = 8;
exports.MAX_PROMO_CODE_LENGTH = 20;
exports.MAX_FAVORITE_PROMO_CODES_COUNT = 6;
//# sourceMappingURL=promo-code.consts.js.map